import { Component, Directive, ChangeDetectionStrategy, ViewEncapsulation, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-panel',
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { 'class' : 'panel' }
})
export class PanelComponent {
  @HostBinding('class.no-padding')
  @Input('no-padding')
  noPadding: boolean = false;
  @HostBinding('class.selected')
  @Input('selected')
  selected: boolean;
  @HostBinding('class.highlighted')
  @Input('highlighted')
  highlighted: boolean = false;  
}

@Component({
  selector: 'app-panel-header',
  templateUrl: './panel-header.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {'class': 'panel-header'}
})
export class PanelHeaderComponent {
  @HostBinding('class.panel-header-small')
  @Input()
  small: boolean = false;
}

@Component({
  selector: 'app-panel-footer',
  templateUrl: './panel-footer.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {'class': 'panel-footer'}
})
export class PanelFooterComponent {}

@Directive({
  selector: 'app-panel-title',
  host: { 'class': 'panel-title' }
})
export class PanelTitle {}
